import { createAction, props } from "@ngrx/store";
import { Policy } from "../../core/models/policy";

export const clearPolicies = createAction("[Policies] Clear Policies");

export const setPolicies = createAction(
  "[Policies] Set Policies",
  props<{
    policies: Policy[];
  }>()
);
